require('bootstrap');
global.$ = global.jQuery = require('jquery');
window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Next we will register the CSRF Token as a common header with Axios so that
 * all outgoing HTTP requests automatically have it attached. This is just
 * a simple convenience so we don't have to attach every token manually.
 */

var token = document.head.querySelector('meta[name="csrf-token"]');

if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}

window.swal = require('sweetalert2');
window.Dropzone = require('dropzone').default;
window.Dropzone.autoDiscover = false;
window.select2 = require('select2');


//////////////////
// WEBPACK FOOTER
// ./resources/js/bootstrap.js
// module id = 56
// module chunks = 0